import React, { useState, useEffect } from 'react';
import { AppBar, Avatar, Button, Toolbar, Typography } from '@material-ui/core';
import { Link, useHistory, useLocation } from 'react-router-dom';
import decode from 'jwt-decode';
import memoriesLogo from '../../images/memories-Logo.png';
import memoriesText from '../../images/memories-Text.png';
import useStyles from './styles';
import { useDispatch } from 'react-redux';
import { LoginActionType } from '../../constants/actionTypes';


const Navbar = () => {
    const classes = useStyles();
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    const displatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const logout = () => {
        displatch({ type: LoginActionType.LOGOUT });
        history.push('/');
        setUser(null);
    };

    const token = user?.token;
    
    useEffect(() => {
        if (token) {
            const decodedToken = decode(token);
            if (decodedToken.exp * 1000 < new Date().getTime()) {
                logout();
            }
        }
        setUser(JSON.parse(localStorage.getItem('profile')));        
    }, [location, token]);

    return (
        <AppBar className={classes.appBar} position="static" color="inherit">
            <div className={classes.brandContainer}>
                <Link to="/" className={classes.brandContainer}>
                    <img src={memoriesText} alt="memories-icon" height="45px" />
                    <img className={classes.image} src={memoriesLogo} alt="memories" height="40px" />
                </Link>
            </div>
            <Toolbar className={classes.toolbar}>
                { user ? (
                    <div className={classes.profile}>
                        <Avatar className={classes.purple} alt={user.result.name} src={user.result.imageUrl}>{user.result.name.charAt[0]}</Avatar>
                        <Typography className={classes.userName} variant="h6">{user.result.name}</Typography>
                        <Button variant="contained" className={classes.logout} color="secondary" onClick={logout}>Logout</Button>
                    </div>
                ) : (
                    <Button  component={Link} to="/auth" variant='contained' color='primary' >Login</Button>
                ) }
            </Toolbar>
        </AppBar>
    );
}

export default Navbar;